<template>
    <div class="master-table-cell-selection">
        <label class="checkbox-container">
            <input ref="checkbox" type="checkbox" :checked="value" @change="onChange"/>
            <span class="checkmark"></span>
        </label>
    </div>
</template>

<script>
export default {
    name: 'MasterTableCellSelection',

    props: {
        rowId: [Number, String],
        value: Boolean
    },

    methods: {
        onChange() {
            this.$emit('input', this.$refs.checkbox.checked);
        }
    }
}
</script>

<style scoped>
.master-table-cell-selection {
    background: transparent;
    display: none;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 0;
    width: 40px;
    position: relative;
}

.selector .master-table-cell-selection,
.multiselector .master-table-cell-selection,
.selectable .master-table-cell-selection {
    display: flex;
}

.master-table-cell-selection .checkbox-container {
    background: transparent;
    display: block;
    position: relative;
    padding-left: 40px;
    margin-bottom: 0px;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
    height: 100%;
}

.master-table-cell-selection input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.master-table-cell-selection input[type=checkbox] {
    height: 20px;
    width: 20px;
    left: 10px;
    top: 15px;
    opacity: 0;
    z-index: 1;
    margin: 0;
}

.master-table-cell-selection .checkmark {
    position: absolute;
    background: url('../../assets/images/SVG/checkbox.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top left;
    top: 15px;
    left: 10px;
    height: 20px;
    width: 20px;
}

.master-table-cell-selection input:checked {
    border-color: transparent;
}

.master-table-cell-selection .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 0px;
    top: 0px;
    width: 20px;
    height: 20px;
    background: url('../../assets/images/SVG/checkbox-checked.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top left;
}

.master-table-cell-selection input:checked~.checkmark:after {
    display: block;
}
</style>
